<template>
  <div class="hb-preview">
    <div class="hb-preview__switcher">
      <button
        class="hb-preview__tab"
        :class="{ 'hb-preview__tab--active': variant === 'mobile' }"
        @click="variant = 'mobile'"
      >
        <i class="pi pi-mobile"></i> موبايل
      </button>
      <button
        class="hb-preview__tab"
        :class="{ 'hb-preview__tab--active': variant === 'desktop' }"
        @click="variant = 'desktop'"
      >
        <i class="pi pi-desktop"></i> ديسكتوب
      </button>
    </div>

    <DeviceFrame :variant="variant" class="hb-preview__frame">
      <div class="hb-preview__viewport-inner">
        <iframe
          ref="iframeRef"
          class="hb-preview__iframe"
          :src="previewUrl"
          title="معاينة الصفحة الرئيسية"
          @load="preview.onFrameLoad"
        ></iframe>
        <div v-if="preview.ready === false" class="hb-preview__status">
          <span class="loader"></span>
          <p>جارِ تحميل المعاينة...</p>
        </div>
        <div v-else-if="preview.ready === 'error'" class="hb-preview__status hb-preview__status--error">
          <i class="pi pi-exclamation-triangle"></i>
          <p>تعذّر الاتصال بالمعاينة. تأكد من صحة رابط الموقع المعاين وحاول تحديث الصفحة.</p>
        </div>
      </div>
    </DeviceFrame>
  </div>
</template>

<script>
import DeviceFrame from './DeviceFrame.vue';
import { useHomepagePreview } from '@/composables/useHomepagePreview.js';

export default {
  name: 'PreviewPanel',
  components: { DeviceFrame },
  props: {
    sections: { type: Array, default: () => [] },
    selectedKey: { type: String, default: null },
  },
  emits: ['section-click'],
  data() {
    return {
      variant: 'mobile',
      preview: useHomepagePreview(),
    };
  },
  computed: {
    previewUrl() {
      // No query params, matching the reference implementation exactly —
      // updates are pushed entirely via postMessage, not the iframe URL.
      return `${this.preview.previewOrigin.replace(/\/$/, '')}/__preview/home`;
    },
  },
  watch: {
    sections: {
      deep: true,
      handler(sections) {
        this.preview.updateSections(sections);
      },
    },
    selectedKey(key) {
      this.preview.updateSelection(key);
    },
    variant() {
      // New <iframe> means a fresh handshake — attach() resets `ready`.
      this.$nextTick(() => this.preview.attach(this.$refs.iframeRef));
    },
  },
  mounted() {
    this.preview.setSectionClickHandler((key) => this.$emit('section-click', key));
    this.preview.updateSections(this.sections);
    this.preview.updateSelection(this.selectedKey);
    this.preview.attach(this.$refs.iframeRef);
  },
  beforeUnmount() {
    this.preview.dispose();
  },
};
</script>

<style scoped>
.hb-preview__switcher {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.hb-preview__tab {
  border: 1px solid var(--surface-border, #e5e7eb);
  background: #fff;
  border-radius: 999px;
  padding: 0.4rem 1.1rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--text-secondary, #64748b);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
.hb-preview__tab--active {
  background: #111827;
  color: #fff;
  border-color: #111827;
}
.hb-preview__viewport-inner {
  position: relative;
  width: 100%;
  height: 100%;
}
.hb-preview__iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}
.hb-preview__status {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  background: rgba(255, 255, 255, 0.92);
  color: var(--text-secondary, #64748b);
  font-size: 0.85rem;
  text-align: center;
  padding: 1rem;
}
.hb-preview__status--error { color: #dc2626; }
.hb-preview__status--error i { font-size: 1.6rem; }
.loader {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(17, 24, 39, 0.15);
  border-top-color: #111827;
  border-radius: 50%;
  display: inline-block;
  animation: hb-spin 0.8s linear infinite;
}
@keyframes hb-spin { to { transform: rotate(360deg); } }
</style>
